import React, { PropTypes } from 'react';
import Translate from 'react-translate-component';

export class InvoiceDetailsDates extends React.Component {

  static propTypes = {
    invoice: PropTypes.object
  };

  renderInvoiceDates () {
    const invoiceDates = [];
    this.props.invoice.invoiceDates.forEach((date) => {
      invoiceDates.push(
        <div
          key={date.date}
          className='invoice-details-date-container'
        >
          <div className='invoice-details-date'>
            {date.date}
          </div>
          <div className='invoice-details-date-divider'></div>
          <div className='invoice-details-date'>
            {date.hours}
          </div>
        </div>
      );
    });
    return invoiceDates;
  }

  render () {
    let invoice = this.props.invoice;
    if (invoice) {
      return (<div className='invoice-details-part-container'>
        <Translate className='invoice-details-title' content='INVOICE_DETAILS_WORK_DATES' />
        <div className='invoice-details-border-container'>
          <div className='invoice-details-dates'>
            {this.renderInvoiceDates()}
          </div>
        </div>
      </div>);
    }
    return null;
  }
}

export default InvoiceDetailsDates;



/** WEBPACK FOOTER **
 ** ./src/components/invoice-details/dates.js
 **/